export const SBTableUnfoldingContent = (props) => {
	const UnfoldingComponent = props.unfoldingComponent;
	return (
		<UnfoldingComponent
			style={{ minHeight: "50vh", padding: "20px 0", width: "100%" }}
			{...props}
		/>
	);
};
